import { useState } from 'react';
import SectionHeading from '@/pages/home/components/SectionHeading';
import { groups } from '@/mocks/home';

export default function CommunityZone() {
  const [toast, setToast] = useState('');
  const [joined, setJoined] = useState<Record<number, boolean>>({});
  const [contact, setContact] = useState('');
  const [tipText, setTipText] = useState('');

  const showToast = (message: string) => {
    setToast(message);
    window.setTimeout(() => setToast(''), 2600);
  };

  const handleJoin = (id: number, name: string) => {
    setJoined((prev) => ({ ...prev, [id]: true }));
    showToast(`已向「${name}」发送入群申请（演示）`);
  };

  const handleSubmitTip = () => {
    if (!contact.trim() || !tipText.trim()) {
      showToast('请先填写联系方式和爆料内容哦');
      return;
    }
    showToast('爆料已收到，等待编辑部分类归档（演示）');
    setContact('');
    setTipText('');
  };

  return (
    <section id="community" className="scroll-mt-28 border-b border-background-200 bg-background-100">
      <div className="mx-auto max-w-[1280px] px-4 py-14 md:px-6 md:py-20">
        <SectionHeading
          no="04"
          english="Community"
          title="瓜友群 & 爆料通道"
          desc="找同好就去分区群，手里有料就往这里递。汇聚全网瓜友，热闹从来不是一个人的事。"
        />

        <div className="mt-12 grid grid-cols-1 gap-8 lg:grid-cols-12">
          {/* 分区群 */}
          <div className="lg:col-span-7">
            <div className="flex items-center gap-2">
              <i className="ri-group-line text-primary-600" />
              <h3 className="font-heading text-lg font-bold text-foreground-950">按兴趣分区</h3>
              <span className="ml-auto font-label text-[11px] text-foreground-500">共 5 个在线分区</span>
            </div>

            <div className="mt-5 grid grid-cols-1 gap-4 sm:grid-cols-2">
              {groups.map((group) => (
                <div
                  key={group.id}
                  className="flex flex-col rounded-lg border border-background-300 bg-background-50 p-5"
                >
                  <div className="flex items-center justify-between">
                    <span className="rounded-full bg-accent-100 px-2.5 py-1 font-label text-[11px] text-accent-900">{group.tag}</span>
                    <span className="font-label text-[11px] text-foreground-500">{group.members}</span>
                  </div>
                  <h4 className="mt-4 font-heading text-base font-bold text-foreground-950">{group.name}</h4>
                  <p className="mt-1.5 flex-1 text-xs leading-relaxed text-foreground-600">{group.desc}</p>
                  <button
                    type="button"
                    disabled={joined[group.id]}
                    onClick={() => handleJoin(group.id, group.name)}
                    className={
                      'mt-4 flex cursor-pointer items-center justify-center gap-1.5 whitespace-nowrap rounded-md px-4 py-2.5 font-label text-sm transition-colors ' +
                      (joined[group.id]
                        ? 'bg-secondary-100 text-secondary-900'
                        : 'bg-primary-500 text-background-50 hover:bg-primary-600')
                    }
                  >
                    <i className={joined[group.id] ? 'ri-check-line' : 'ri-add-line'} />
                    {joined[group.id] ? '已申请' : '申请加入'}
                  </button>
                </div>
              ))}
            </div>
          </div>

          {/* 爆料面板 */}
          <div className="lg:col-span-5">
            <div className="rounded-lg border border-background-300 bg-foreground-950 p-6 text-background-100 md:p-7">
              <div className="flex items-center gap-2">
                <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-foreground-950">
                  <i className="ri-megaphone-line" />
                </span>
                <div>
                  <h3 className="font-heading text-lg font-bold text-background-50">我要爆料</h3>
                  <p className="font-label text-[11px] tracking-wide text-background-400">TIPS &nbsp;SUBMISSION</p>
                </div>
              </div>

              <p className="mt-5 text-sm leading-relaxed text-background-300">
                手上有路透、截图或时间线？递进来，编辑部分类后同步到快讯流与会话合集。我们会保护投稿人信息。
              </p>

              <div className="mt-6 flex flex-col gap-4">
                <div className="flex flex-col gap-2">
                  <label htmlFor="tip-contact" className="font-label text-xs text-background-300">联系方式</label>
                  <input
                    id="tip-contact"
                    type="text"
                    value={contact}
                    onChange={(e) => setContact(e.target.value)}
                    placeholder="邮箱或社交账号，方便回访"
                    className="w-full rounded-md border border-background-50/15 bg-background-50/5 px-4 py-3 text-sm text-background-50 placeholder:text-background-500 focus:border-accent-400 focus:outline-none"
                  />
                </div>
                <div className="flex flex-col gap-2">
                  <label htmlFor="tip-content" className="font-label text-xs text-background-300">爆料内容</label>
                  <textarea
                    id="tip-content"
                    value={tipText}
                    maxLength={500}
                    onChange={(e) => setTipText(e.target.value)}
                    rows={4}
                    placeholder="描述一下事情经过、时间点与关键细节"
                    className="w-full resize-none rounded-md border border-background-50/15 bg-background-50/5 px-4 py-3 text-sm text-background-50 placeholder:text-background-500 focus:border-accent-400 focus:outline-none"
                  />
                  <span className="self-end font-label text-[11px] text-background-500">{tipText.length} / 500</span>
                </div>
                <button
                  type="button"
                  onClick={handleSubmitTip}
                  className="flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-5 py-3 font-label text-sm font-medium text-foreground-950 transition-colors hover:bg-accent-400"
                >
                  <i className="ri-send-plane-line" />
                  提交爆料
                </button>
                <p className="text-center font-label text-[11px] text-background-500">本页为静态展示，提交不会真实发送</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {toast && (
        <div className="fixed bottom-6 left-1/2 z-[60] -translate-x-1/2 rounded-md bg-foreground-950 px-5 py-3 font-label text-sm text-background-50 shadow-lg">
          <span className="flex items-center gap-2 whitespace-nowrap">
            <i className="ri-information-line text-accent-400" />
            {toast}
          </span>
        </div>
      )}
    </section>
  );
}